import KnackApiWrapper from '@knack/api-wrapper';

const knackApiWrapperSettings = {
  api_uri: process.env.VUE_APP_API_URL,
};

const Api = new KnackApiWrapper(knackApiWrapperSettings);

export default Api;
